import React, { useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import _get from 'lodash/get';

import { Button } from 'reaxl';

import getPreorderAvailability, { isSingleYear } from '@/utilities/getPreorderAvailability';
import getUniqueMakeModelPairs from '@/utilities/getUniqueMakeModelPairs';
import { isCurrentModelAvailable } from '@/utilities/useCompareTrimsData';

import {
    kbbVRSDataDuck,
    preorderDuck,
} from '@/ducks';

import {
    srpActiveInteractionDuck,
    srpFiltersDuck,
} from '@/ducks/srp';

/*
 * link in Trim filter that will make a VRS call when loaded
 */
function CompareTrimsLink({
    index = 0,
    trimFilterOptions,
    bsStyle = 'text',
    className = 'padding-bottom-2',
    children = 'Compare Trims',
    ...rest
}) {
    const dispatch = useDispatch();

    const filtersRequestValues = useSelector(srpFiltersDuck.selectors.getRequestValues);
    const filtersValues = useSelector(srpFiltersDuck.selectors.getFiltersValues);
    const activeModel = _get(useSelector(srpActiveInteractionDuck.selectors.getDuckState), 'activeModel', '');
    const activeTrims = useSelector(kbbVRSDataDuck.selectors.getActiveModelTrims);
    const compareTrimsData = useSelector(kbbVRSDataDuck.selectors.getCompareTrims);

    const loadTrimData = (options) => dispatch(preorderDuck.creators.loadTrimData(options));
    const loadVehicleSpecs = () => dispatch(kbbVRSDataDuck.creators.loadVehicleSpecs());
    const loadVrsData = (options) => dispatch(kbbVRSDataDuck.creators.loadData(options));
    const setActiveInteraction = (options) => dispatch(srpActiveInteractionDuck.creators.setKeys(options));

    // extract current make and model of the trim link
    const currentModel = trimFilterOptions?.value;
    const currentMake = trimFilterOptions?.name?.split('|')?.[1];

    const showCompareTrimLink = (typeof currentModel === 'string' || currentModel?.length === 1) && getPreorderAvailability(filtersRequestValues)
        && isCurrentModelAvailable(currentMake, currentModel, compareTrimsData);

    // load vrs data for first 3 models selected, but only when first trim link displays
    useEffect(() => {
        const isSingleYearSearch = isSingleYear(filtersValues);

        if (getPreorderAvailability(filtersRequestValues) && index === 0 && activeModel !== 'none') {
            const makeModelPairs = getUniqueMakeModelPairs({ filtersValues, multiYear: !isSingleYearSearch }).slice(0, 6);
            loadVrsData({
                enableFetchOptions: false,
                key: 'compareTrims',
                makeModelPairs,
                selectedModel: activeModel,
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeModel, filtersValues]);

    // fetch vehicle specs for each trim and load trim data into preorder store
    useEffect(() => {
        if (showCompareTrimLink) {

            loadVehicleSpecs();
            loadTrimData({ activeTrims });

            const activeTrimsFuelTypes = Array.from(new Set(activeTrims.map((trim) => trim.engineType)));

            if (activeTrimsFuelTypes.length > 0) {
                setActiveInteraction({
                    fuelTypeOptions: activeTrimsFuelTypes.map((value) => {
                        const label = value === 'Gas' ? 'Gasoline' : value;
                        return { label, value };
                    }),
                });
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [compareTrimsData, filtersRequestValues]);

    if (showCompareTrimLink) {
        return (
            <Button
                bsStyle={bsStyle}
                className={className}
                {...rest}
            >
                {children}
            </Button>
        );
    }

    return null;

}

export default CompareTrimsLink;
